import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import GenericFilters from '../../generic-filters/GenericFilters';

function PredictFilters({ onSort, sort }) {
  const { t } = useTranslation('genie');

  const predictedMessages = useSelector((state) => state.genie.predictedMessages);
  const predictedInitMessage = useSelector((state) => state.genie.predictedInitMessage);
  const projectName = useSelector((state) => state.genie.projectName);
  const isPredicting = useSelector((state) => state.genie.isPredicting);
  const isGeneratingAlternate = useSelector((state) => state.genie.isGeneratingAlternate);

  const getExportMessages = (messages) => [{ count: t('initialMessage'), ...predictedInitMessage }, ...messages];

  return (
    <GenericFilters
      messages={predictedMessages}
      projectName={projectName}
      exportContext='predicted'
      onSort={onSort}
      sort={sort}
      isDisabled={isPredicting || isGeneratingAlternate}
      getExportMessages={getExportMessages}
    />
  );
}

export default PredictFilters;
